import { useState } from 'react';
import { InsuranceDetailQueries } from '@frontend/api-insurance-detail';
import { GlobalBannerDynamic } from '@frontend/global-info-banner';
import { useTranslation } from '@frontend/i18n';
import { useGetWeaveEnhancedInsuranceVerificationCustomizationFlagDetails } from '@frontend/insurance-verification';
import { useAppScopeStore } from '@frontend/scope';
import { useSettingsNavigate } from '@frontend/settings-routing';

export const ConnectPayersBanner = () => {
  const { t } = useTranslation('insuranceDetails');
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const { navigate } = useSettingsNavigate();
  const { selectedLocationIds } = useAppScopeStore();
  const { locationIdWiseCustomizationFlagDetails } = useGetWeaveEnhancedInsuranceVerificationCustomizationFlagDetails();

  const locationId = selectedLocationIds[0];
  const isEnhancedInsuranceVerificationEnabled = locationIdWiseCustomizationFlagDetails?.[locationId!] || false;

  const { isLoading, isError, data } = InsuranceDetailQueries.useGetPayerConnectionDetails(locationId, {
    enabled: isEnhancedInsuranceVerificationEnabled,
  });

  const shouldShowBanner = !isLoading && !isError;
  const showErrorBanner = shouldShowBanner && data?.connectionCount === 0;
  const showWarningBanner = shouldShowBanner && data?.connectionCount && data?.connectionCount >= 1;

  if (bannerDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setBannerDismissed(true);
  };

  if (showErrorBanner) {
    return (
      <GlobalBannerDynamic
        type='error'
        id='connect-payers-error-universal-banner'
        message={t('Insurance eligibility results may be incomplete or limited without payer credentials.')}
        title={t('Missing Payer Connections')}
        trackingId='connect-payers-button-universal-banner-error'
        action={{
          label: t('Connect Payers'),
          onClick: () => {
            navigate({ to: '/insurance/payer-connection-management' });
          },
        }}
        isDismissible={true}
        onDismiss={handleDismiss}
      />
    );
  } else if (showWarningBanner) {
    return (
      <GlobalBannerDynamic
        type='warning'
        id='connect-payers-warning-universal-banner'
        message={t('Add payer credentials to expand coverage and unlock more complete insurance eligibility results.')}
        title={t('Add Payer Connections')}
        trackingId='connect-payers-button-universal-banner-warning'
        action={{
          label: t('Connect Payers'),
          onClick: () => {
            navigate({ to: '/insurance/payer-connection-management' });
          },
        }}
        isDismissible={true}
        onDismiss={handleDismiss}
      />
    );
  }
  return null;
};
